import React from 'react'
import { Link } from "react-router";


export default function Footer() {
  return (
    <footer>
      <div className='footer-container'>
        <nav>
          <Link to="/about">Kik vagyunk?</Link> 
          <Link to="/references">Referenciák </Link>
          <Link to="/services">Szolgáltatások</Link>
          <Link to="/contact">Kapcsolat</Link>
        </nav>
      </div>
    </footer>
  )
}
